import React, { Component } from 'react';
import { bool, node, string, func } from 'prop-types';
import cn from 'classnames';
import Modal from 'react-modal';
import modal from './ModalContainer.module.scss';
// import { Icon } from '../../index';
// https://github.com/reactjs/react-modal/issues/632
if (process.env.NODE_ENV !== 'test') {
  // Make sure to bind modal to your appElement (http://reactcommunity.org/react-modal/accessibility/)
  Modal.setAppElement('#root');
}
/**
 * @augments {Component<Props, State>}
 */
class ModalContainer extends Component {
  static propTypes = {
    className: string,
    bodyClassName: string,
    overlayClassName: string,
    closeModalWindow: func,
    isOpen: bool,
    ariaHideApp: bool,
    header: node,
    title: node,
    children: node,
    footer: node,
    disableScroll: bool,
    hideCloseBtn: bool,
    isFullscreen: bool,
    maxWidth: string,
    shouldCloseOnOverlayClick: bool,
    shouldCloseOnEsc: bool,
    dataFeatureTarget: string,
  };
  static defaultProps = {
    disableScroll: false,
    hideCloseBtn: true
  };
  componentDidMount() {
    if (this.props.isOpen) {
      this.disableScroll();
    }
  }
  componentDidUpdate(prevProps) {
    const { isOpen: prevIsOpen } = prevProps;
    const { isOpen } = this.props;
    if (!prevIsOpen && isOpen) {
      this.disableScroll();
    } else if (prevIsOpen && !isOpen) {
      this.enableScroll();
    }
  }
  componentWillUnmount() {
    this.enableScroll();
  }
  disableScroll() {
    const { disableScroll } = this.props;
    if (!disableScroll) {
      return;
    }
    const scrollWidth =
      window.innerWidth - document.documentElement.clientWidth;
    if (scrollWidth > 0) document.body.style.paddingRight = `${scrollWidth}px`;
    document.body.style.overflow = 'hidden';
  }
  enableScroll() {
    const { disableScroll } = this.props;
    if (!disableScroll) {
      return;
    }
    document.body.style.paddingRight = '';
    document.body.style.overflow = '';
  }
  render() {
    const {
      className,
      bodyClassName,
      closeModalWindow,
      isOpen,
      header,
      title,
      children,
      footer,
      hideCloseBtn,
      isFullscreen,
      maxWidth,
      dataFeatureTarget,
      ...rest
    } = this.props;
    if (!isOpen) {
      return null;
    }
    return (
      <Modal
        // classname for the whole wrapper
        // content is rendered inside overlay
        overlayClassName={cn(modal['react-modal__overlay'], {
          [className]: !!className,
        })}
        className={cn(modal['react-modal__body'], {
          [bodyClassName]: !!bodyClassName,
        })}
        isOpen={isOpen}
        onRequestClose={closeModalWindow}
        {...rest}
      >
        <div className={modal['react-modal__holder']}>
          {(title || header) && (
            <div className={modal['react-modal__header']}>
              <h2>{title}</h2>
              <p>{header}</p>
            </div>
          )}
          <div className={modal['react-modal__content']}>{children}</div>
          {/* {footer && <div className="react-modal__footer">{footer}</div>} */}
          {/* {closeModalWindow && !hideCloseBtn && (
            <button
              className="react-modal__btn-close"
              onClick={closeModalWindow}
              type="button"
            >
              <Icon name="clear" />
            </button>
          )} */}
        </div>
      </Modal>
    );
  }
}
export default ModalContainer;
